import { useIntl } from 'react-intl';

import { useActionData, useSubmit } from 'react-router';
import { useContext } from 'react';
import Button from 'client/components/aria/Button/Button';
import { SAVE_OBSERVATION_PAGE } from 'client/utils/routes/routeConstants';
import { getGeoJsonGeometry } from 'client/utils/map/geometryUtils';
import { MapContext } from 'os-elements';

const ContinueObservationButton = () => {
    const actionData = useActionData() || {};
    const { draftObservation } = actionData;
    const submit = useSubmit();
    const intl = useIntl();
    const { map } = useContext(MapContext);

    const handleOnPress = () => {
        const formData = new FormData();
        const aoiGeoJson = getGeoJsonGeometry(map, 'aoi');
        formData.append('geometry', aoiGeoJson);
        formData.append('draftObservation', JSON.stringify(draftObservation));
        submit(formData, {
            action: SAVE_OBSERVATION_PAGE,
            method: 'put'
        });
    };

    return <Button data-testid="mapToolBar.observation.continue"
        variant="error"
        onPress={handleOnPress}>
        { intl.formatMessage({ id: 'general.cancel' }) }
    </Button>;
};

export default ContinueObservationButton;
